import { useCallback, useMemo } from 'react'
import { useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'
import type { TabType } from 'app/components/ui/nav-tabs'

const enum Sections {
  CHANNEL = `channels`,
  SOURCE = `sources`,
  MEDIUM = `media`,
  PLATFORM = `platforms`,
  PMS_REFERRAL = `referral`,
  CDT_CODES = `cdt-codes`,
  FORMS = `forms`,
}

export type UseSettingsMappingReturn = {
  title: string
  tabs: TabType[]
}

export function useSettingsMapping(): UseSettingsMappingReturn {
  const user = useUser()

  const tabs = useMemo(() => {
    const isSMC = isSMCOrg(user?.orgId)
    const allTabs: TabType[] = [
      { name: `PMS Referral`, href: Sections.PMS_REFERRAL },
      { name: `CDT Codes`, href: Sections.CDT_CODES },
      { name: `Forms`, href: Sections.FORMS },
    ]

    if (!isSMC) {
      allTabs.push(
        { name: `Channel`, href: Sections.CHANNEL },
        { name: `Source`, href: Sections.SOURCE },
        { name: `Medium`, href: Sections.MEDIUM },
        { name: `Platform`, href: Sections.PLATFORM },
      )
    }

    return allTabs
  }, [user?.orgId])

  return {
    title: 'Mapping',
    tabs,
  }
}
